<template>

    <Tippy arrow placement="right" max-width="200" v-if="discountPercentage">
        <template v-slot:trigger>
            <div class="price-n-discount">
                <div class="discount">
                    <span class="percentageOff">
                        {{ discountPercentage * 100 }}%
                    </span>
                    <StripePrice :price="price" class="initialPriceStroked" />
                </div>
                <StripePrice :price="price - price * discountPercentage" />
            </div>
        </template>

        <div class="price-n-discount-tooltip">
            <f-icon icon="fa6-circle-info" inline></f-icon>
            <div v-html="discountTooltip">
            </div>
        </div>
    </Tippy>


    <div v-else>
        <StripePrice :price="price" />
    </div>
</template>
<script>

import StripePrice from "/vodalys2023/stripe/main/components/StripePrice.vue";
export default {
    components: {
        StripePrice
    },
    props: {
        price: Number,
        discountPercentage: Number | undefined,
        discountTooltip: String | undefined
    },
}</script>
<style lang="scss">
.price-n-discount-tooltip {
    display: flex;
    flex-direction: row;
    gap: 8px;

    justify-content: center;
}

.price-n-discount {

    display: flex;
    flex-direction: column;
    gap: 8px;


    .discount {

        display: flex;
        justify-content: center;
        gap: 8px;

        .percentageOff {
            display: flex;
            padding: 4px 6px 5px 6px;
            justify-content: center;
            align-items: center;

            border-radius: 4px;
            background: var(--Primary-300, #5FDFDF);
            background: var(--Primary-300, #5FDFDF);

            color: var(--black, #191919);
            text-align: center;

            /* Text/Font-size 75/Bold */
            font-family: Lato;
            font-size: 12px;
            font-style: normal;
            font-weight: 700;
            line-height: 125%;
            /* 15px */
        }

        .initialPriceStroked {
            color: var(--white-75, rgba(255, 255, 255, 0.75));
            text-align: right;
            font-family: Lato;
            font-size: 30px;
            font-style: normal;
            font-weight: 700;
            line-height: 100%;
            /* 30px */
            text-decoration: line-through;
        }
    }
}
</style>